import { memo } from "react";
import { useParams } from "react-router-dom";
import type { PurchaseParamsT } from "./models/models";
import getPurchasePageBasedOnPackageType from "./helpers/getPurchasePageBasedOnPackageType";
import { useUser } from "../../../contexts/userContext/userContext";
import PurchaseSideDetails from "./components/PurchaseSideDetails";
import useSpecialNotification from "./hooks/useSpecialNotification";
import SpecialNotification from "../../Reusable/Notifications/SpecialNotification";
import isPurchaseResultPage from "./helpers/isPurchaseResultPage";
import useInitializePurchasePage from "./hooks/useInitializePurchasePage";

import styles from "./styles.module.scss";
import checkIfPrivatePage from "./helpers/checkIfPrivatePage";
import LoadingImageElement from "../../Elements/LoadingContainerElement/LoadingImageElement";

/**
 * Wrapper component for purchase pages.
 */

const Purchases = memo(() => {
  // Set the currency, coupon code and set payment method and
  // credit card token according to the billing cycle
  useInitializePurchasePage();

  const { packageType } = useParams<PurchaseParamsT>();
  const { isSubscribed, isLoggedIn } = useUser();
  const { displaySpecialNotification, destinationUrl } =
    useSpecialNotification();

  // Get the Page to render according to packageType URL parameter
  const PurchasePage = getPurchasePageBasedOnPackageType(packageType!);

  const isPageDisplayAllowed = checkIfPrivatePage() ? isLoggedIn() : true;

  return (
    <>
      {displaySpecialNotification && !isSubscribed() && (
        <SpecialNotification
          isActive={displaySpecialNotification}
          destinationUrl={destinationUrl as unknown as null}
        />
      )}
      <div className={styles.wrapper}>
        {isPageDisplayAllowed ? (
          <div
            className={
              isPurchaseResultPage() ? styles.resultContent : styles.content
            }
          >
            <PurchasePage
              // Need to pass this prop for "page not found" case
              // because Error component has no types yet
              // TODO: add types for Error.js
              customType={undefined}
            />
            <div className={styles.asideDetails}>
              <PurchaseSideDetails />
            </div>
          </div>
        ) : (
          <div className={styles.loadingContainer}>
            <LoadingImageElement />
          </div>
        )}
      </div>
    </>
  );
});

export default Purchases;
